import { lang } from '@umu/ukit-lang';
/**
 * @description 考试提交时间设置 封装
 * @interface wike 及接口说明 https://wiki.umu.work/pages/viewpage.action?pageId=27597211
 */

import { components, services } from 'common';
const { AlertDialog: alert } = components;
const { Toast } = services;
import { customFormatDateTime } from '@umu/umu-util';
import { PARTICIPATE_STATUS } from '@umu/umu-types';
import { getParticipateStatus } from '@umu/umu-api';

import { config } from 'common';
const { NO_PERMISSION } = config;

export const PARTICIPATE_STATUS_TEXT: any = {
    [PARTICIPATE_STATUS.ONBEFORE]: '', // 该多语不会出现 只是语义表达
    [PARTICIPATE_STATUS.ONSTART]: lang('未开始'),
    [PARTICIPATE_STATUS.PENDING]: lang('进行中'),
    [PARTICIPATE_STATUS.ONEND]: lang('已结束'),
};

type ICallBack = any;
// 学员没有权限的管理
export { NO_PERMISSION, ICallBack };

export default class SubmissionTime {
    /**
     * @param {*} startTime
     * @param {*} endTime
     * @param {*} participateStatus
     */
    public static getPermissionTimeText(startTime: string, endTime: string, participateStatus?: PARTICIPATE_STATUS) {
        let timeText = '';
        if (!+startTime && !+endTime) {
            return timeText;
        }
        if (+startTime > 0 && +endTime > 0) {
            startTime = customFormatDateTime(+startTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
            endTime = customFormatDateTime(+endTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
            timeText = lang('提交时间为 {$0} 至 {$1}', startTime, endTime);
            if (participateStatus && participateStatus === PARTICIPATE_STATUS.ONEND) {
                timeText = lang('已于 {$0} 结束提交', endTime);
            }
        }

        if (+startTime > 0 && !+endTime) {
            startTime = customFormatDateTime(+startTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
            timeText = lang('将于 {$0} 开始提交', startTime);
        }
        if (!+startTime && +endTime > 0) {
            endTime = customFormatDateTime(+endTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
            timeText = `${lang('已于 {$0} 结束提交', endTime)} `;
        }

        return timeText;
    }
    /**
     *
     * @param {*} startTime
     * @param {*} endTime
     */
    public static getPermissionDoingTimeText(
        startTime: string,
        endTime: string,
        participateStatus: PARTICIPATE_STATUS,
    ) {
        let timeText = '';

        // 未开始

        if (participateStatus === PARTICIPATE_STATUS.ONSTART) {
            if (+startTime > 0 && +endTime > 0) {
                startTime = customFormatDateTime(+startTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
                endTime = customFormatDateTime(+endTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
                timeText = lang('提交时间为 {$0} 至 {$1}', startTime, endTime);
                return timeText;
            }
            if (+startTime > 0) {
                startTime = customFormatDateTime(+startTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
                timeText = lang('将于 {$0} 开始提交', startTime);
                return timeText;
            }
        }

        //  进行中

        if (participateStatus === PARTICIPATE_STATUS.PENDING) {
            if (+endTime > 0) {
                endTime = customFormatDateTime(+endTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
                timeText = lang('将于 {$0} 结束提交', endTime);
                return timeText;
            }
        }

        // 已结束

        if (participateStatus === PARTICIPATE_STATUS.ONEND) {
            if (+endTime > 0) {
                endTime = customFormatDateTime(+endTime * 1000 || 0, 'yyyy-MM-dd hh:mm');
                timeText = lang('已于 {$0} 结束提交', endTime);
                return timeText;
            }
        }
        return timeText;
    }

    public static async onGetParticipateStatus(sessionId: number, callBack: ICallBack) {
        const participateStatus = await getParticipateStatus({ session_id: sessionId });
        if (NO_PERMISSION.indexOf(participateStatus.participate_status) > -1) {
            callBack(Object.assign({}, participateStatus, { isNoPermission: false, isLoading: false }));
            return;
        }
        callBack(Object.assign({}, participateStatus, { isNoPermission: true, isLoading: false }));
    }

    public static setTimeFormat(time: number) {
        const minute = Math.floor(time / 60);
        const second = Math.floor(time % 60);
        return minute ? minute + lang('分') + second + lang('秒') : second + lang('秒');
    }

    /**
     * @description 上传视频作业校验
     */

    public static async homeWorkUploadValidateData(sessionId: number) {
        const participateStatus = await getParticipateStatus({ session_id: sessionId });
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONSTART &&
            +participateStatus.accept_submission_time
        ) {
            const time = customFormatDateTime(
                +participateStatus.accept_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('无法上传视频作业'),
                content: lang('当前小节于 {$0} 之后才能提交。', time),
            });
            return false;
        }

        if (participateStatus.participate_status === PARTICIPATE_STATUS.ONEND) {
            alert({
                title: lang('无法上传视频作业'),
                content: lang('当前小节已结束提交。'),
            });
            return false;
        }

        return true;
    }

    /**
     * @description 录制作业校验
     */

    public static async homeWorkRecordValidateData(
        sessionId: number,
        mediaTimeLowestLimit: number,
        callBack: () => void,
    ) {
        const participateStatus = await getParticipateStatus({ session_id: sessionId });
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONSTART &&
            +participateStatus.accept_submission_time
        ) {
            const time = customFormatDateTime(
                +participateStatus.accept_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('无法录制视频作业'),
                content: lang('当前小节于 {$0} 之后才能提交。', time),
            });
            return false;
        }
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.PENDING &&
            +participateStatus.refuse_submission_time
        ) {
            const duration = +participateStatus.refuse_submission_time - Date.now() / 1000;
            mediaTimeLowestLimit = +mediaTimeLowestLimit / 1000;
            const maxDuration = 30 * 60;
            if (+mediaTimeLowestLimit) {
                if (+mediaTimeLowestLimit <= duration) {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    if (duration <= maxDuration && duration > 0) {
                        alert({
                            title: lang('请注意时间'),
                            content: lang('距离小节结束提交时间仅剩{$0}。', tips),
                            submitBtnClick: () => {
                                callBack();
                            },
                        });
                        return false;
                    }
                } else {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    const tips1 = lang('距离小节结束还有{$0}， ', tips);
                    const time = String(Math.floor(+mediaTimeLowestLimit / 60));
                    const tips2 = lang('少于小节要求的最低作业时长{$0}分钟。', time);
                    alert({
                        title: lang('无法录制视频作业'),
                        content: tips1 + tips2,
                        className: 'umu-system-alert-dialog',
                    });
                    return false;
                }
            } else {
                if (duration < maxDuration) {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    alert({
                        title: lang('请注意时间'),
                        content: lang('距离小节结束提交时间仅剩{$0}。', tips),
                        className: 'umu-system-alert-dialog',
                        submitBtnClick: () => {
                            callBack();
                        },
                    });
                    return false;
                }
            }
        }

        if (participateStatus.participate_status === PARTICIPATE_STATUS.ONEND) {
            alert({
                title: lang('无法录制视频作业'),
                content: lang('当前小节已结束提交。'),
                className: 'umu-system-alert-dialog',
            });
            return false;
        }
        return true;
    }

    /**
     * 作业验证
     */
    public static async homeWorkValidateData(
        sessionId: number,
        mediaTimeLowestLimit: number,
        callBack: () => void,
        isUpload?: boolean,
    ) {
        const participateStatus = await getParticipateStatus({ session_id: sessionId });
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONSTART &&
            +participateStatus.accept_submission_time
        ) {
            const time = customFormatDateTime(
                +participateStatus.accept_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('作业提交失败!'),
                content: lang('提交时间将于 {$0} 开始。', time),
            });
            return false;
        }
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.PENDING &&
            +participateStatus.refuse_submission_time
        ) {
            const duration = +participateStatus.refuse_submission_time - Date.now() / 1000;
            mediaTimeLowestLimit = +mediaTimeLowestLimit / 1000;
            const maxDuration = 30 * 60;
            if (+mediaTimeLowestLimit) {
                if (+mediaTimeLowestLimit <= duration) {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    if (duration <= maxDuration && duration > 0) {
                        alert({
                            title: lang('请注意时间'),
                            content: lang('距离小节结束提交时间仅剩{$0}。', tips),
                            submitBtnClick: () => {
                                callBack();
                            },
                        });
                        return false;
                    }
                } else {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    const tips1 = lang('距离小节结束还有{$0}， ', tips);
                    const time = String(Math.floor(+mediaTimeLowestLimit / 60));
                    const tips2 = lang('少于小节要求的最低作业时长{$0}分钟。', time);
                    if (isUpload) {
                        alert({
                            title: lang('作业提交失败'),
                            content: tips1 + tips2,
                            className: 'umu-system-alert-dialog',
                        });
                        return false;
                    }
                    alert({
                        title: lang('无法录制视频作业'),
                        content: tips1 + tips2,
                        className: 'umu-system-alert-dialog',
                    });
                    return false;
                }
            } else {
                if (duration < maxDuration) {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    alert({
                        title: lang('请注意时间'),
                        content: lang('距离小节结束提交时间仅剩{$0}。', tips),
                        className: 'umu-system-alert-dialog',
                        submitBtnClick: () => {
                            callBack();
                        },
                    });
                    return false;
                }
            }
        }

        if (participateStatus.participate_status === PARTICIPATE_STATUS.ONEND) {
            const time = customFormatDateTime(
                +participateStatus.refuse_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('作业提交失败'),
                content: lang('提交时间已于 {$0} 结束。', time),
                className: 'umu-system-alert-dialog',
            });
            return false;
        }
        return true;
    }

    /**
     * @description 上传文档作业校验
     */

    public static async docHomeWorkUploadValidateData(sessionId: number) {
        const participateStatus = await getParticipateStatus({ session_id: sessionId });
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONSTART &&
            +participateStatus.accept_submission_time
        ) {
            const time = customFormatDateTime(
                +participateStatus.accept_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('作业提交失败'),
                content: lang('当前小节于 {$0} 之后才能提交。', time),
            });
            return false;
        }

        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONEND &&
            +participateStatus.refuse_submission_time
        ) {
            const time = customFormatDateTime(
                +participateStatus.refuse_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('作业提交失败'),
                content: lang('提交时间已于 {$0} 结束。', time),
            });
            return false;
        }

        return true;
    }

    /**
     * 重新提交视频作业
     */
    public static async reUploadValidateData(sessionId: number, mediaTimeLowestLimit: number, callBack: () => void) {
        const participateStatus = await getParticipateStatus({ session_id: sessionId });
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONSTART &&
            +participateStatus.accept_submission_time
        ) {
            const time = customFormatDateTime(
                +participateStatus.accept_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('无法重新提交视频作业'),
                content: lang('当前小节于 {$0} 之后才能提交。', time),
            });
            return false;
        }
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.PENDING &&
            +participateStatus.refuse_submission_time
        ) {
            const duration = +participateStatus.refuse_submission_time - Date.now() / 1000;
            mediaTimeLowestLimit = +mediaTimeLowestLimit / 1000;
            const maxDuration = 30 * 60;
            if (+mediaTimeLowestLimit) {
                if (+mediaTimeLowestLimit <= duration) {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    if (duration <= maxDuration && duration > 0) {
                        alert({
                            title: lang('请注意时间'),
                            content: lang('距离小节结束提交时间仅剩{$0}。', tips),
                            submitBtnClick: () => {
                                callBack();
                            },
                        });
                        return false;
                    }
                } else {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    const tips1 = lang('距离小节结束还有{$0}， ', tips);
                    const time = String(Math.floor(+mediaTimeLowestLimit / 60));
                    const tips2 = lang('少于小节要求的最低作业时长{$0}分钟。', time);
                    alert({
                        title: lang('无法重新提交视频作业'),
                        content: tips1 + tips2,
                        className: 'umu-system-alert-dialog',
                    });
                    return false;
                }
            } else {
                if (duration < maxDuration) {
                    const tips = SubmissionTime.setTimeFormat(duration);
                    alert({
                        title: lang('请注意时间'),
                        content: lang('距离小节结束提交时间仅剩{$0}。', tips),
                        className: 'umu-system-alert-dialog',
                        submitBtnClick: () => {
                            callBack();
                        },
                    });
                    return false;
                }
            }
        }

        if (participateStatus.participate_status === PARTICIPATE_STATUS.ONEND) {
            alert({
                title: lang('无法重新提交视频作业'),
                content: lang('当前小节已结束提交。'),
                className: 'umu-system-alert-dialog',
            });
            return false;
        }
        return true;
    }
    /**
     * 问卷验证
     */
    public static async surveyValidateData(sessionId: number, isToast?: boolean) {
        const participateStatus = await getParticipateStatus({ session_id: sessionId });
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONSTART &&
            +participateStatus.accept_submission_time
        ) {
            const time = customFormatDateTime(
                +participateStatus.accept_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            if (isToast) {
                Toast.show({
                    message: lang('当前小节于 {$0} 之后才能提交。', time),
                });
                return false;
            }
            alert({
                title: lang('问卷提交失败'),
                content: lang('提交时间将于 {$0} 开始。', time),
                className: 'umu-system-alert-dialog',
            });
            return false;
        }
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONEND &&
            +participateStatus.refuse_submission_time
        ) {
            if (isToast) {
                Toast.show({
                    message: lang('当前小节已结束提交'),
                });
                return false;
            }
            const time = customFormatDateTime(
                +participateStatus.refuse_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('问卷提交失败'),
                content: lang('提交时间已于 {$0} 结束。', time),
                className: 'umu-system-alert-dialog',
            });
            return false;
        }
        return true;
    }
    /**
     * 问卷逐题互动 校验
     */
    public static async followValidateData(sessionId: number) {
        const participateStatus = await getParticipateStatus({ session_id: sessionId });
        if (
            participateStatus.participate_status === PARTICIPATE_STATUS.ONSTART &&
            +participateStatus.accept_submission_time
        ) {
            const time = customFormatDateTime(
                +participateStatus.accept_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('问卷提交失败'),
                content: lang('提交时间将于 {$0} 开始。', time),
                className: 'umu-system-alert-dialog',
            });
        }
        if (participateStatus.participate_status === PARTICIPATE_STATUS.ONEND) {
            const time = customFormatDateTime(
                +participateStatus.refuse_submission_time * 1000 || 0,
                'yyyy-MM-dd hh:mm',
            );
            alert({
                title: lang('问卷提交失败'),
                content: lang('提交时间已于 {$0} 结束。', time),
                className: 'umu-system-alert-dialog',
                // submitBtnClick:()=> {
                //     $window.location.reload()
                // },
            });
        }
    }
}
